import type { BodyConfigRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { UploadedFileDataObject } from 'models/service';

type UploadFileBody = FormData | UploadFileFromUrlBody;

type UploadFileConfigParams = Record<string, never>;

type UploadFileFromUrlBody = {
  name: string;
  url: string;
};

export const uploadFile = async ({ body, config }: BodyConfigRequest<UploadFileBody, UploadFileConfigParams>) =>
  apiClient.post<UploadedFileDataObject, ApiClientResponse<UploadedFileDataObject>>(routes.files.upload, body, config);
